import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=ff726c6c&scoped=true&"
import script from "./CookieBar.vue?vue&type=script&lang=js&"
export * from "./CookieBar.vue?vue&type=script&lang=js&"
import style0 from "./CookieBar.vue?vue&type=style&index=0&id=ff726c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff726c6c",
  null
  
)

export default component.exports